import { render, staticRenderFns } from "./VueMyModal.vue?vue&type=template&id=2804c088&"
import script from "./VueMyModal.vue?vue&type=script&lang=js&"
export * from "./VueMyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2804c088')) {
      api.createRecord('2804c088', component.options)
    } else {
      api.reload('2804c088', component.options)
    }
    module.hot.accept("./VueMyModal.vue?vue&type=template&id=2804c088&", function () {
      api.rerender('2804c088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/modal/VueMyModal.vue"
export default component.exports